var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseStatusEditor',{attrs:{"usedColors":_vm.usedColors},on:{"create":_vm.create,"update":_vm.update,"remove":_vm.remove},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var onCreate = ref.onCreate;
var onUpdate = ref.onUpdate;
var onRemove = ref.onRemove;
return [_c('BaseStatusTile',{attrs:{"value":_vm.value,"items":_vm.items,"changeable":_vm.changeable,"editable":_vm.editable,"gray":_vm.gray},on:{"change":function($event){return _vm.$emit('change', $event)},"create":onCreate,"update":onUpdate,"remove":onRemove}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }